import { BlocksIconEdit } from 'blocks-nextjs/blocks-web-components/components/icon/icons/edit';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconEdit = createComponent({ react: React, tagName: 'cat-icon-edit', elementClass: BlocksIconEdit });
